import { useLocation } from "react-router-dom";

const ROUTE_MAP = {
    "/dashboard": { section: "Payin", title: "Dashboard" },
    "/payinWallet": { section: "Payin", title: "Wallet" },
    "/payinWalletReport": { section: "Payin", title: "Wallet Report" },
    "/transactions": { section: "Payin", title: "Transactions" },
    "/ptpreport": { section: "Payin", title: "PTP Report" },
    "/ptpmanualupdate": { section: "Payin", title: "PTP Manual Update" },
    "/payoutDashboard": { section: "Payout", title: "Dashboard" },
    "/payoutWallet": { section: "Payout", title: "Wallet" },
    "/reversal": { section: "Payout", title: "Reversal" },
    "/passbook": { section: "Payout", title: "Passbook" },
    "/servicemanagement": { section: "Master", title: "Service Management" },
    "/procmanagement": { section: "Master", title: "Processor Management" },
    "/addReseller": { section: "Master", title: "Reseller Management" },
    "/pendingmerchantmanagement": { section: "Merchant Management", title: "Pending" },
    "/approvedmerchantmanagement": { section: "Merchant Management", title: "Approved" },
};

export default function Navbar({ title }) {
    const location = useLocation();
    const route = ROUTE_MAP[location.pathname];
    const pageTitle = route?.title || title || "Overview";
    const section = route?.section;

    const today = new Date().toLocaleDateString(undefined, {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
    });

    return (
        <header className="app-header sticky-top">
            <div className="app-header__titles">
                {section && <span className="app-header__eyebrow">{section}</span>}
                <h1 className="app-header__title">{pageTitle}</h1>
            </div>
            <div className="app-header__meta">
                <i className="fa-regular fa-calendar"></i>
                <span>{today}</span>
            </div>
        </header>
    );
}
